module.exports = __webpack_public_path__ + "img/LLY.0994a60b.png";